import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "btn btn-belgium px-4 py-2" }
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = { class: "row d-flex justify-content-center align-items-center text-center" }
const _hoisted_7 = { class: "col-md-3 d-flex justify-content-center" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 w-100" }
const _hoisted_9 = { class: "col-md-3 d-flex justify-content-center" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 w-100" }
const _hoisted_11 = { class: "col-md-3 d-flex justify-content-center" }
const _hoisted_12 = { class: "search-box position-relative d-flex" }
const _hoisted_13 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_14 = { class: "table-responsive" }
const _hoisted_15 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-black pe-0 text-end" }
const _hoisted_22 = {
  class: "dropdown-menu dropdown-block",
  "data-popper-placement": "bottom-start"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "d-flex justify-content-between mt-3" }
const _hoisted_27 = {
  class: "modal fade",
  id: "create-task",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_28 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_29 = { class: "modal-content" }
const _hoisted_30 = { class: "modal-body px-4" }
const _hoisted_31 = { class: "row gy-2" }
const _hoisted_32 = { class: "col-md-4-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_AddPaiementModal = _resolveComponent("AddPaiementModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
          _createElementVNode("a", {
            class: "btn btn-primary",
            href: "#",
            "data-bs-toggle": "modal",
            "data-bs-target": "#AddPaiementModal"
          }, [
            _createElementVNode("i", { class: "fa fa-plus-circle" }),
            _createTextVNode(" Ajouter un paiement ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", _hoisted_4, " Montant total : " + _toDisplayString(_ctx.totalMontant), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date de début ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateDebut) = $event)),
                class: "form-control me-2",
                placeholder: "Date début"
              }, null, 512), [
                [_vModelText, _ctx.dateDebut]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date de fin ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dateFin) = $event)),
                class: "form-control me-2",
                placeholder: "Date fin"
              }, null, 512), [
                [_vModelText, _ctx.dateFin]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("form", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.motCle) = $event)),
                class: "form-control",
                placeholder: "Rechercher une facture"
              }, null, 512), [
                [_vModelText, _ctx.motCle]
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("button", {
                type: "submit",
                class: "bg-transparent text-primary transition p-0 border-0 ms-2"
              }, [
                _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
              ], -1))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("table", _hoisted_15, [
            _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, "REFERENCE"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, "MONTANT"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, "FACTURE"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, "DATE DE PAIEMENT"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, "STATUT"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
                }, " Actions")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Paiements, (paiement, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_16, _toDisplayString(paiement.reference), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(paiement.montant), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(paiement?.paiementFactures?.[0]?.facture?.reference), 1),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.format_date(paiement.date_paiement)), 1),
                  _createElementVNode("td", _hoisted_20, [
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.getStatutBadge(paiement.statut)?.badgeClass)
                    }, _toDisplayString(_ctx.getStatutBadge(paiement.statut)?.text), 3)
                  ]),
                  _createElementVNode("td", _hoisted_21, [
                    _cache[9] || (_cache[9] = _createElementVNode("button", {
                      class: "btn btn-sm btn-primary",
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, "Actions", -1)),
                    _createElementVNode("ul", _hoisted_22, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          onClick: ($event: any) => (_ctx.openNewWindow(paiement)),
                          type: "button",
                          class: "dropdown-item d-flex align-items-center"
                        }, _cache[7] || (_cache[7] = [
                          _createElementVNode("i", { class: "flaticon-send lh-1 me-8 position-relative top-1" }, null, -1),
                          _createTextVNode(" Reçu de paiement ")
                        ]), 8, _hoisted_23)
                      ]),
                      (paiement.statut !== 'Payé' && paiement.statut !== 'ANNULE')
                        ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                            _createElementVNode("a", {
                              href: "javascript:void(0);",
                              "data-bs-target": "#create-task",
                              "data-bs-toggle": "modal",
                              onClick: ($event: any) => (_ctx.openModal(paiement.id)),
                              class: "dropdown-item d-flex align-items-center"
                            }, _cache[8] || (_cache[8] = [
                              _createElementVNode("i", { class: "flaticon-close lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Annuler ")
                            ]), 8, _hoisted_25)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h6", { class: "modal-title" }, "Voulez-vous annuler cette facture ?"),
            _createElementVNode("button", {
              type: "button",
              id: "close-modal",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_Form, {
              ref: "depensesForm",
              onSubmit: _ctx.addPaiements,
              "validation-schema": _ctx.paiementsSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block fw-semibold mb-10" }, [
                      _createTextVNode(" Motif"),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "motifAnnuler",
                      as: "textarea",
                      placeholder: "Entrer l'observation",
                      class: "form-control shadow-none rounded-0 text-black"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "motifAnnuler",
                      class: "text-danger"
                    })
                  ])
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "modal-footer" }, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary"
                  }, "Annuler"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger",
                    "data-bs-dismiss": "modal",
                    "aria-label": "Close"
                  }, " Fermer ")
                ], -1))
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_AddPaiementModal, {
      onGetAllPaiements: _ctx.rechercher,
      id: _ctx.idpaiement,
      onOpenmodal: _ctx.showModalEdite
    }, null, 8, ["onGetAllPaiements", "id", "onOpenmodal"])
  ], 64))
}